module.exports = __webpack_public_path__ + "static/Otchetnost_1_polugodie_2020-0cfe13aa9186fe33ade8ea9803942ab4.pdf";